import { ref } from 'vue'

// استرجع البيانات من التخزين
const storedUser = JSON.parse(localStorage.getItem('user')) || null
const storedUserId = localStorage.getItem('userId')

// أدمج userId مع user
if (storedUser && storedUserId) {
  storedUser.id = parseInt(storedUserId)
}

const isAuthenticated = ref(!!localStorage.getItem('access_token'))
const user = ref(storedUser)

function login() {
  isAuthenticated.value = true
  const freshUser = JSON.parse(localStorage.getItem('user')) || {}
  const freshId = localStorage.getItem('userId')
  if (freshId) {
    freshUser.id = parseInt(freshId)
  }
  user.value = freshUser
}

function logout() {
  localStorage.removeItem('access_token')
  localStorage.removeItem('user')
  localStorage.removeItem('userId')
  isAuthenticated.value = false
  user.value = null
}

export default function useAuth() {
  return {
    isAuthenticated,
    user,
    login,
    logout
  }
}
